import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import AddHolidayName, {openAddHoliday} from "./addHoliday.controller";
import template from './holidays.tpl.html';
import {States} from "../../shared/config/constant.module";
import HolidaysServiceName, {HolidaysService} from "../../services/holidays/holidays.service";

let requires = [AddHolidayName, HolidaysServiceName];

export interface HolidaysController {
  year: number;
  prevYear(): any;
  nextYear(): any;
  holidays: apsViewModels.Holiday[];
  addHoliday(): any;
  deleteHoliday(holiday: apsViewModels.Holiday): any;
}

export default angular.module('aps.controller.holidays', requires)
  .config(holidaysRoute)
  .controller('HolidaysCtrl', holidaysCtrl)
  .name;

function holidaysRoute($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.HOLIDAYS,
    url: '/admin/holidays',
    controller: 'HolidaysCtrl as holidaysCtrl',
    template: template,
    data: {
      pageTitle: 'Holidays',
      authorizeAdmin: true
    }
  });
}

function holidaysCtrl(
  $modal: mm.foundation.modal,
  holidaysService: HolidaysService) {
  'use strict';
  let vm = <HolidaysController>this;

  vm.year = new Date().getFullYear();
  loadHolidays();

  vm.prevYear = function() {
    vm.year --;
    loadHolidays();
  };

  vm.nextYear = function () {
    vm.year ++;
    loadHolidays();
  };

  function loadHolidays() {
    holidaysService.getHolidays(vm.year).then( (result) => {
      vm.holidays = result;
    });
  }

  vm.addHoliday = function() {
    let result = openAddHoliday({
      year: vm.year
    }, $modal);

    result.then(function () {
      loadHolidays();
    });
  };

  vm.deleteHoliday = function (holiday) {
    let command = {
      id: holiday.id
    };

    holidaysService.deleteHoliday(command).then(function () {
      loadHolidays();
    });
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/holidays/holidays.controller.ts